import { clientsApi } from '@modules/clients/entities/client/api';
import { toast } from '@huspy/forge/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';

const useClientDetails = (id?: string | null, companyId?: string) => {
  const { isFeatureActive } = useFeatureFlags();
  const isClientCompanyActive = isFeatureActive('clients.companyClients');
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['clientDetails', id],
    queryFn: () => (isClientCompanyActive
      ? clientsApi.getCompanyClientDetails(companyId!, id!)
      : clientsApi.getClientDetails(id!)),
    staleTime: 1_800_000,
    placeholderData: keepPreviousData,
    enabled: isClientCompanyActive ? !!id && !!companyId : !!id,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useClientDetails;
